import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSubAdmins,
  addSubAdmin as addLang,
  updateSubAdmin as updateLang,
  deleteSubAdmin as deleteLang,
  updateSubAdminStatus as updateLangStatus,
} from "../../services/subAdminService";
import { toast } from "react-toastify";

const initialState = {
  subAdmins: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all subAdmins
export const fetchSubAdmins = createAsyncThunk(
  "subAdmins/fetchSubAdmins",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubAdmins();
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Add a new subAdmin
export const addSubAdmin = createAsyncThunk(
  "subAdmins/addSubAdmin",
  async (subAdmin, { rejectWithValue }) => {
    try {
      const response = await addLang(subAdmin);
      toast.success(response.message || "Data added successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);



// Update a subAdmin
export const updateSubAdmin = createAsyncThunk(
  "subAdmins/updateSubAdmin",
  async ({ id, subAdmin }, { rejectWithValue }) => {
    try {
      const response = await updateLang(id, subAdmin);
      toast.success(response.message || "Data updated successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Update a subAdmin status
export const updateSubAdminStatus = createAsyncThunk(
  "subAdmins/updateSubAdminStatus",
  async ({ id, statusObj }, { rejectWithValue }) => {
    try {
      const response = await updateLangStatus(id, statusObj);
      toast.success(response.message || "Status updated successfully!");
      return { id, statusObj };
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Delete a subAdmin
export const deleteSubAdmin = createAsyncThunk(
  "subAdmins/deleteSubAdmin",
  async (id, { rejectWithValue }) => {
    try {
      let response = await deleteLang(id);
     toast.success(response.message || "Data deleted successfully!");
      return id;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

const subAdminSlice = createSlice({
  name: "subAdmins",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch SubAdmins
      .addCase(fetchSubAdmins.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSubAdmins.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subAdmins = action.payload.data;
      })
      .addCase(fetchSubAdmins.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

       // Update SubAdmin Status
       .addCase(updateSubAdminStatus.fulfilled, (state, action) => {
        const {id,statusObj} = action.payload;

        // Ensure `state.languages` exists and is an array
        if (!Array.isArray(state.subAdmins)) {
            return;
        }
        const index = state.subAdmins.findIndex((subAdmin) =>{
         return subAdmin._id === id
        });
        if (index !== -1) {
          state.subAdmins[index] = { ...state.subAdmins[index], ...statusObj };
        }
      })

        // Add SubAdmin
            .addCase(addSubAdmin.fulfilled, (state, action) => {
              state.subAdmins.unshift(action.payload.data); // Add at the beginning
            })
      
            // Update SubAdmin
            .addCase(updateSubAdmin.fulfilled, (state, action) => {
              const updatedSubAdmin = action.payload.data;
      
              if (!Array.isArray(state.subAdmins)) {
                  return;
              }
              const index = state.subAdmins.findIndex((subAdmin) =>{
               return subAdmin._id === updatedSubAdmin._id
              });
              if (index !== -1) {
                state.subAdmins[index] = { ...state.subAdmins[index], ...updatedSubAdmin };
              }
            })


       // Delete Language
       .addCase(deleteSubAdmin.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.subAdmins = state.subAdmins.filter((astro) => astro._id !== deletedId);
      });
     
  },
});

export const { clearError } = subAdminSlice.actions;
export default subAdminSlice.reducer;
